import {
    MANAGEMENT_SAGA_AUTHENTICATE_LOKET,
    MANAGEMENT_SAGA_DEL_USER_PLANNING_PREFERENCE,
    MANAGEMENT_SAGA_EXPORT_USERS_CSV,
    MANAGEMENT_SAGA_GET_PERMISSION_GROUPS,
    MANAGEMENT_SAGA_GET_USER_SHIFTS,
    MANAGEMENT_SAGA_GET_USERS_QUICKLY,
    MANAGEMENT_SAGA_LINK_USER_TO_LOKET,
    MANAGEMENT_SAGA_LINK_USERS_TO_LOKET,
    MANAGEMENT_SAGA_SET_SORTING,
    MANAGEMENT_SAGA_SET_USER_PLANNING_PREFERENCE,
} from '../actionTypes'

const getUsersQuickly = (pageNumber) => ({ type: MANAGEMENT_SAGA_GET_USERS_QUICKLY, pageNumber })
const setUsersSorting = (sortType, ascending) => ({ type: MANAGEMENT_SAGA_SET_SORTING, sortType, ascending })
const authenticateLoket = (state, code) => ({ type: MANAGEMENT_SAGA_AUTHENTICATE_LOKET, state, code })
const exportUsersCSV = () => ({ type: MANAGEMENT_SAGA_EXPORT_USERS_CSV })
const linkUserToLoket = userId => ({ type: MANAGEMENT_SAGA_LINK_USER_TO_LOKET, userId })
const linkUsersToLoket = () => ({ type: MANAGEMENT_SAGA_LINK_USERS_TO_LOKET })
const getUserShifts = (userId, startDate, endDate) => ({
    type: MANAGEMENT_SAGA_GET_USER_SHIFTS,
    userId,
    startDate,
    endDate,
})
const getPermissionGroups = () => ({ type: MANAGEMENT_SAGA_GET_PERMISSION_GROUPS })
const setUserPlanningPreference = (
    weekday,
    fromDate,
    toDate,
    comment,
    userId,
    planningPreferenceId,
    page,
) => (
    {
        type: MANAGEMENT_SAGA_SET_USER_PLANNING_PREFERENCE,
        weekday,
        fromDate,
        toDate,
        comment,
        userId,
        planningPreferenceId,
        page,
    }
)
const deleteUserPlanningPreference = (planningPreferenceId) => ({ type: MANAGEMENT_SAGA_DEL_USER_PLANNING_PREFERENCE, planningPreferenceId })

export {
    authenticateLoket,
    deleteUserPlanningPreference,
    exportUsersCSV,
    getPermissionGroups,
    getUserShifts,
    getUsersQuickly,
    linkUsersToLoket,
    linkUserToLoket,
    setUserPlanningPreference,
    setUsersSorting,
}
